// extracted by mini-css-extract-plugin
export var hidden = "_u7-0";